
const PatternTokenizer = require("./patternTokenizer");
class Variable extends PatternTokenizer {
    static variableNamePattern = "([a-zA-Z_$][a-zA-Z\\d_$]*)";

    constructor() {
        super("variable", new RegExp("^" + Variable.variableNamePattern + "$"));
    }

    parse(tokens, current) {
        return [current + 1,
            {
                type: 'VariableLiteral',
                value: tokens[current].value,
                getInterpolatedValue: this.interpolateValue.bind(this, tokens[current].value),
                params: []
            }];
    }
}

module.exports = Variable;
